const Cdata=[
    {
    "id": 1,
    "title": "Africa Switzerland Australia",
    "price": 2500,
    "description": "Alaska Rafting on the Tatshenshini River",
    "category": "1",
    "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2017/05/des-1.jpg",
    },
    {
    "id": 2,
    "title": "Portugal Switzerland Bahamas",
    "price": 4500,
    "description": "Proof That Bahamas Beaty Really Works",
    "category": "2",
    "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2017/01/des-2.jpg",
    },
    {
    "id": 3,
    "title": " Africa Canada Portugal",
    "price":4500,
    "description": "Win Friends And Influence People with canada tour",
    "category": "3",
    "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2017/01/des-3.jpg",
    },
    {
        "id": 4,
        "title": "Portugal Jamaica",
        "price": 2500,
        "description": "Now You Can Have",
        "category": "1",
        "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2017/01/des-9-768x512.jpg",
        },
        {
        "id": 5,
        "title": " Africa Canada Mexico",
        "price": 4500,
        "description": "Believe In Your Mexico",
        "category": "5",
        "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2017/01/des-8-768x512.jpg",
        },
        {
        "id": 6,
        "title": "Africa Canada Fiji",
        "price":4500,
        "description": "Take The Stress Out",
        "category": "6",
        "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2017/01/des-7-768x512.jpg",
        },
]
export default Cdata;